/* Deep mega menu: wrap-safe hover (patches theme's HeaderMenu), pane swap, toggles */
(function () {
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- 1) Temanın HeaderMenu.onMouseLeave'ini wrap-güvenli yap ---- */
  function patchedOnMouseLeave() {
    clearTimeout(this.hoverIntentTimer);
    clearTimeout(this._wrapSafeCloseTimer);
    var self = this;

    this._wrapSafeCloseTimer = setTimeout(function () {
      if (!self.mainDetailsToggle.open || self.preventHoverClose) return;

      var dropdown = self.summary && self.summary.nextElementSibling;
      var nav = self.closest('.header__inline-menu');
      var stillInside =
        self.matches(':hover') ||
        (dropdown && dropdown.matches(':hover')) ||
        (nav && nav.matches(':hover'));

      if (stillInside) return; /* imleç hâlâ nav/panel içinde: kapatma */

      self.classList.remove('open');
      self.style.setProperty('--header-zindex', '0');
      self.summary.click();
    }, 300);
  }

  function applyPatch() {
    var HM = customElements.get('header-menu');
    if (!HM || HM.prototype._wrapSafePatched) return;
    HM.prototype._wrapSafePatched = true;
    HM.prototype.onMouseLeave = patchedOnMouseLeave;

    /* init'i bizden ÖNCE çalışmış instance'ların eski handler'ını değiştir */
    document.querySelectorAll('header-menu').forEach(function (hm) {
      if (hm.mouseLeaveHandler) {
        hm.removeEventListener('mouseleave', hm.mouseLeaveHandler);
        hm.mouseLeaveHandler = patchedOnMouseLeave.bind(hm);
        hm.addEventListener('mouseleave', hm.mouseLeaveHandler);
      }
    });
  }

  if (FINE) {
    customElements.whenDefined('header-menu').then(applyPatch);
  }

  /* Nav'dan tamamen çıkınca açık menüleri kapat (satır-2'de bekleyip yandan çıkma durumu) */
  function initNavCloser() {
    if (!FINE) return;
    document.querySelectorAll('.header__inline-menu').forEach(function (nav) {
      if (nav.dataset.navCloserInit) return;
      nav.dataset.navCloserInit = 'true';
      nav.addEventListener('mouseleave', function () {
        setTimeout(function () {
          nav.querySelectorAll('header-menu details[open]').forEach(function (d) {
            var hm = d.closest('header-menu');
            if (!hm || hm.preventHoverClose) return;
            var dropdown = hm.summary && hm.summary.nextElementSibling;
            var inside = hm.matches(':hover') || (dropdown && dropdown.matches(':hover')) || nav.matches(':hover');
            if (!inside) {
              hm.classList.remove('open');
              hm.style.setProperty('--header-zindex', '0');
              hm.summary.click();
            }
          });
        }, 250);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavCloser);
  } else {
    initNavCloser();
  }
  document.addEventListener('shopify:section:load', initNavCloser);

  /* ---- 2) Rail hover -> sağ panel (değişiklik yoksa DOM'a dokunma) ---- */
  function activatePane(el) {
    var menu = el.closest('.deep-mega');
    if (!menu) return;
    var id = el.getAttribute('data-deep-target');
    var pane = document.getElementById(id);
    if (!pane || pane.classList.contains('is-active')) return;

    menu.querySelectorAll('.deep-mega__pane.is-active').forEach(function (p) { p.classList.remove('is-active'); });
    pane.classList.add('is-active');

    menu.querySelectorAll('.deep-mega__rail-item.is-active').forEach(function (li) { li.classList.remove('is-active'); });
    var item = el.closest('.deep-mega__rail-item');
    if (item) item.classList.add('is-active');
  }

  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest('.deep-mega [data-deep-target]');
    if (el) activatePane(el);
  });
  document.addEventListener('focusin', function (e) {
    var el = e.target.closest('.deep-mega [data-deep-target]');
    if (el) activatePane(el);
  });

  /* ---- 3) Tıklamalar — capture-phase ---- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.deep-mega__rail-arrow');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      activatePane(arrow);
      return;
    }
    var btn = e.target.closest('[data-deep-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var group = btn.closest('.deep-mega__group');
      var list = group && group.querySelector('.deep-mega__group-list');
      if (!list) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      list.hidden = isOpen;
    }
  }, true);
})();